import { byMedia } from '../helpers/media';
export const justifyMap = new Map();
justifyMap.set('start', 'flex-start');
justifyMap.set('end', 'flex-end');
justifyMap.set('center', 'center');
justifyMap.set('between', 'space-between');
justifyMap.set('around', 'space-around');
export const justifyKeys = ['start', 'end', 'center', 'between', 'around'];
export const justifyContent = byMedia(value => `justify-content: ${justifyMap.get(value) || value};`);
export const justifyItems = byMedia(value => `justify-items: ${justifyMap.get(value) || value};`);
export const justifySelf = byMedia(value => `justify-self: ${justifyMap.get(value) || value};`);